import React, { useState, useEffect } from "react";
import { Popconfirm, Icon, Card, Row, Col, Tag, Tooltip } from "antd";
import moment from "moment";
//import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

// Components
import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import ModalDesingProcess from "../../components/modal-desing-process";
import RenderDesingProcessData from "../../components/render-desing-process-data";

import Colors from "../../theme/colors";

// pages
import DesingProcess from "../design-process";

// Hooks
import useProcessDesings from "../../hooks/useProcessDesings";
import useManufacturingOrder from "../../hooks/useManufacturingOrder";

// Styles
import { ThreeBox } from "./styles";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const ListDesingProcess = ({ changeTitle }) => {
  const [listOfProcessDesing, setListOfProcessDesing] = useState([]);
  const [selectedProcessDesing, setSelectedProcessDesing] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const [edit, setEdit] = useState(false);
  const [editDesingEl, setEditDesingEl] = useState({});

  const [showModalDesing, setShowModalDesing] = useState(false);

  const { processDesings } = useProcessDesings();

  const { getOrderWithDesings } = useManufacturingOrder();

  const dispath = useDispatch();

   //To translate text
   const { t } = useTranslation();

  //const history = useHistory();

  //hange title
  useEffect(() => {
    changeTitle && !edit && changeTitle("designs");
  }, [changeTitle, edit]);

  useEffect(() => {
    const normalized = processDesings.map(design => {
      return {
        key: design.id,
        inUse: getOrderWithDesings().includes(design.id),
        ...design
      };
    });

    normalized && setListOfProcessDesing(normalized);
    if (normalized && normalized[0]) {
      setSelectedProcessDesing(normalized[0]);
      setSelectedRowKey([normalized[0].key]);
    }
  }, [processDesings]);

  const editDesing = record => {
    setEditDesingEl(listOfProcessDesing.find(p => p.id === record.id));
    changeTitle("edit_design", record.desingName);
    setEdit(!edit);
  };

  const deleteArticle = id => {
    const state = {
      id: id
    };
    dispath({ type: "DELETE_DESING", state });
  };

  const handleShowModalDesing = visible => setShowModalDesing(visible);

  const columns = [
    {
      title: t('table.header.name'),
      dataIndex: "desingName",
      key: "desingName",
      sorter: (a, b) => a.desingName.localeCompare(b.desingName),
      defaultSortOrder: "descend",
      ...Search("desingName")
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "articleName",
      sorter: (a, b) => a.article.articleName.localeCompare(b.article.articleName),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.geometry'),
      dataIndex: "article.selected_figure",
      key: "selected_figure",
      sorter: (a, b) => a.article.selected_figure.localeCompare(b.article.selected_figure),
      //...Search("selected_figure"),
      filters: [
        { text: t('geometry.cylinder'), value: "cylinder" },
        { text: t('geometry.rhomboid'), value: "rhomboid" },
        { text: t('geometry.torus'), value: "torus" },
        { text: t('geometry.rectangle'), value: "rectangle" }
      ],
      onFilter: (value, record) => record.article.selected_figure.includes(value),
      render: value => t('geometry.'+value)
    },
    {
      title: t('table.header.type'),
      dataIndex: "article.isPrototype",
      key: "isPrototype",
      width: 100,
      render: article => (article && article.isPrototype ? t('labels.prototype') : t('labels.catalogue')),
      filters: [
        { text: t('labels.prototype'), value: true },
        { text: t('labels.catalogue'), value: false }
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.article.isPrototype === value
    },
    {
      title: t('table.header.design_date'),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: date => moment(date).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.actions'),
      key: "action",
      width: 90,
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip title={record.inUse ? t('button.action.associated_order') : t('button.action.edit', { value: record.desingName })}>
            <Icon type="edit" onClick={() => !record.inUse && editDesing(record)} style={{ color: record.inUse && "#ccc" }} />
          </Tooltip>
          <Popconfirm
            title={t('button.confirm.delete_design', { value: record.desingName })}
            okText={t('button.confirm.yes')}
            onConfirm={() => deleteArticle(record.id)}
            cancelText={t('button.confirm.no')}
            icon={<Icon type="question-circle-o" style={{ color: Colors.danger }} />}
          >
            <Tooltip title={record.inUse ? t('button.action.associated_order') : t('button.action.delete', { value: record.desingName })}>
              <Icon type="delete" style={{ color: record.inUse ? "#ccc" : Colors.danger }} />
            </Tooltip>
          </Popconfirm>
        </Row>
      )
    }
  ];


  // rowSelection objects indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedProcessDesing(processDesings.find(obj => obj.id === record.id));
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
    type: "radio"
  };

  //const goForward = () => history.goForward();

  const editClose = () => {
    setEdit(false);
    //changeTitle("Artículos");
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    setSelectedProcessDesing(processDesings.find(obj => obj.id === row.id));
  };

  return edit ? (
    <DesingProcess edit={true} editArticle={editDesingEl.article} editProcess={editDesingEl} back={true} close={editClose} />
  ) : (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table data={listOfProcessDesing} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedProcessDesing && selectedProcessDesing.desingName}
          extra={
            selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.isPrototype ? (
              <Tag color="magenta">{t('labels.prototype')}</Tag>
            ) : (
              <Tag color="blue">{t('labels.catalogue')}</Tag>
            )
          }
          cover={
            selectedProcessDesing &&
            selectedProcessDesing.article && (
              <ThreeBox>
                <ThreeFigure
                  figureData={selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.figure[0]}
                />
              </ThreeBox>
            )
          }
          actions={[
            <span onClick={() => setShowModalDesing(true)}>
              <Icon type="eye" key="eye" /> {t('button.more_info')}
            </span>
          ]}
        >
          <RenderDesingProcessData selectedProcessDesing={selectedProcessDesing} />
        </Card>
      </Col>

      <ModalDesingProcess visible={showModalDesing} handleVisible={handleShowModalDesing} desing={selectedProcessDesing} />
    </Row>
  );
};

export default ListDesingProcess;
